<template>
    <v-container id="mainhomecontainer" class="ma-0 pa-0">
        <v-col cols="12" md="12" sm="12" class="ma-0 pa-0">
            <!-- <v-img :src="header" class="max-h-200 ma-0 pa-0"></v-img> -->
            <!-- <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p> -->
            <v-col cols="12" class=" pb-0 mb-0">
                <v-img contain :src="juzzapLogo" class="small-logo pa-3"></v-img>
                <p class="txt1-2 pt-3 pb-0 mb-0"><span v-html="$t('zz_strapline_serving_those_serving')"></span></p>
                <p class="txt1-2 mt-2 pt-0 mt-0"><span v-html="$t('zz_strapline_brick_and_mortar')"></span></p>
            </v-col>
            <v-col cols="12" sm="6" offset-sm="3">
            <p class="head-line mt-2 pt-10" v-html="$t('zz_strapline_needs_to_be_simple')"></p>
            <p class="head-line" style="color:black" v-html="$t('zz_strapline_simply_to_br_needed')"></p><br>
            <!-- <p class="txt2" v-html="$t('zz_signup_2')"></p><br> -->
            <p class="txt2 pt-1"><span v-html="$t('zz_signup_1-2')"></span></p><br><br>

            <p class="txt2" v-html="$t('zz_signup_3')"></p><br>
            <div class="prereg" v-html="$t('zz_signup_preregister')">
                    </div>

        </v-col>
        <v-overlay v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-col cols="12" md="12" class=" true-center ">

        <template>
            <div style="" class="">
                <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                    <v-icon color="#FE5800"
                            style="flex:none">
                        mdi-information-variant
                        </v-icon>
                        {{$t('zz_templates_title')}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="info-dropdown">
                    <div v-html="$t('zz_templates_explainer')">
                    </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </template>
        </v-col>


        <v-row>
            <!-- <v-col cols="12" md="12" class="true-center ma-0 pa-0"> -->


            <!-- </v-col> -->
            <v-col class="bus-card-container pa-3 ma-3">
                <v-btn small color="primary" @click="filterType=''">Show All</v-btn>
                <v-btn small outlined color="primary" @click="filterType='foodbev'">{{$t('zz_food_and_beverage')}}</v-btn>
                <v-btn small outlined color="primary" @click="filterType='restaurant'">{{$t('zz_restaurant')}}</v-btn>
                <v-btn small outlined color="primary" @click="filterType='bar'">{{$t('zz_bar')}}</v-btn>
                <v-btn small outlined color="primary" @click="filterType='retail'">{{$t('zz_retail')}}</v-btn>
                <v-btn small outlined color="primary" @click="filterType='wellness'">{{$t('zz_health_wellness')}}</v-btn>
                <!-- <v-btn small outlined color="primary" @click="filterType='petshop'">{{$t('zz_pet_shop')}}</v-btn> -->
                <v-btn small outlined color="primary" @click="filterType='highstreet'">{{$t('zz_highstreet')}}</v-btn>
                <v-btn small outlined color="primary" @click="filterType='gym'">{{$t('zz_gym')}}</v-btn>
                <v-btn small outlined color="primary" @click="filterType='hotel'">{{$t('zz_hotel')}}</v-btn>
                <v-btn small outlined color="primary" @click="filterType='wholeseller'">{{$t('zz_wholeseller')}}</v-btn>
                <v-btn small outlined color="primary" @click="filterType='experience'">{{$t('zz_experience')}}</v-btn>
                <!-- <v-btn small outlined color="primary" @click="filterType='attraction'">{{$t('zz_attraction')}}</v-btn> -->
                <v-btn small outlined color="primary" @click="filterType='eventsorg'">{{$t('zz_events')}}</v-btn>
                <!-- <v-btn small outlined color="primary" @click="filterType='weddings'">{{$t('zz_weddings')}}</v-btn> -->
                <!-- <v-btn small outlined color="primary" @click="filterType='cafe'">{{$t('zz_cafe')}}</v-btn> -->
                <!-- <v-btn small outlined color="primary" @click="filterType='bistrot'">{{$t('zz_bistrot')}}</v-btn> -->
                <!-- <v-btn small outlined color="primary" @click="filterType='fooddrinks'">Food & Drinks Retail</v-btn> -->
                <!-- <v-btn small outlined color="primary" @click="filterType='retail'">{{$t('zz_retail')}}</v-btn> -->
                <!-- <v-btn small outlined color="primary" @click="filterType='sports'">{{$t('zz_sports_club')}}</v-btn> -->







            </v-col>

        </v-row>



        <div no-gutters class="bus-card-container mt-10 px-3">



<!-- BLANK -->
                    <v-col v-if="filterType=='' || filterType=='restaurant' || filterType=='foodbev' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 style="" class="pa-0 ma-0">
                            <!-- <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span> -->
                            <v-img :src="blank" class="main-image" gradient="to top right , rgba(25,25,25,.25), rgba(105,105,105,.5)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_make_your_own')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_blank')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>

                        <v-form v-model="valid"  id="frmblank" autocomplete="off" class="">

                            <v-card elevation=12 class="signup-card px-auto mx-auto">
                                <v-cols cols="12" class="text-center">
                                    <v-row no-gutters class="mx-3 pb-7">
                                        <v-row no-gutters cols="12" md="12" sm="12">
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                    :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"

                                                    id="businessName_blank"
                                                    name="businessName"
                                                    type="text"
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('businessName')"
                                                    data-vv-name="businessName"
                                                    required
                                                    class="styled-input pa-0 m-0 pb-1 pt-4 bname"
                                                    width="100%">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                id="contactFirstName_blank"
                                                :label="$t('zz_tell_us')"
                                                name="contactFirstName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('contactFirstName')"
                                                data-vv-name="contactFirstName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 ownername">
                                            </v-text-field>
                                        </v-row>
                                        <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                :label="$t('zz_enter_email')"
                                                id="email_blank"
                                                name="email"
                                                type="email"
                                                v-validate="'required'"
                                                class="styled-input pa-0 m-0 bemail"
                                                width="100%"
                                                required>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-cols>
                            </v-card>
                            <v-btn  elevation=24 class="button-signup px-3" color="#FE5800" @click="businessRegister('blank','#frmblank','453')">{{$t('zz_lets_go')}}</v-btn>

                        </v-form>
                    </v-col>

<!-- RESTAURANT -->
                    <v-col v-if="filterType=='' || filterType=='restaurant' || filterType=='foodbev' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 style="" class="pa-0 ma-0">
                            <!-- <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span> -->
                            <v-img :src="restaurant" class="main-image" gradient="to top right , rgba(25,25,25,.25), rgba(105,105,105,.5)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_restaurant')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-form v-model="valid"  id="frmrestaurant" autocomplete="off" class="">

                            <v-card elevation=12 class="signup-card px-auto mx-auto">
                                <v-cols cols="12" class="text-center">
                                    <v-row no-gutters class="mx-3 pb-7">
                                        <v-row no-gutters cols="12" md="12" sm="12">
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                    :label="$t('zz_whats_your') +' '+ $t('zz_restaurant') +' '+ $t('zz_called')+' ?'"
                                                    v-model="businessName_restaurant"
                                                    name="businessName"
                                                    type="text"
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('businessName')"
                                                    data-vv-name="businessName"
                                                    required
                                                    class="styled-input pa-0 m-0 pb-1 pt-4 bname"
                                                    width="100%">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field

                                                v-model="contactFirstName_restaurant"
                                                :label="$t('zz_tell_us')"
                                                name="contactFirstName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('contactFirstName')"
                                                data-vv-name="contactFirstName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 ownername">
                                            </v-text-field>
                                        </v-row>
                                        <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                v-model="email_restaurant"
                                                :label="$t('zz_enter_email')"
                                                name="email"
                                                type="email"
                                                v-validate="'required'"
                                                class="styled-input pa-0 m-0 bemail"
                                                width="100%"
                                                required>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-cols>
                            </v-card>
                            <v-btn  elevation=24 class="button-signup px-3" color="#FE5800" @click="businessRegister('restaurant','#frmrestaurant','453')">{{$t('zz_lets_go')}}</v-btn>
                        </v-form>

                    </v-col>

<!-- BAR -->
                    <v-col v-if="filterType=='' || filterType=='bar' || filterType=='foodbev' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <!-- <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span> -->
                            <v-img :src="bar" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <!-- <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p> -->
                                <p class="bus-type-heading ">{{$t('zz_bar')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-form v-model="valid"  id="frmbar" autocomplete="off" class="">

                            <v-card elevation=12 class="signup-card px-auto mx-auto">
                                <v-cols cols="12" class="text-center">
                                    <v-row no-gutters class="mx-3 pb-7">
                                        <v-row no-gutters cols="12" md="12" sm="12">
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                    :label="$t('zz_whats_your') +' '+ $t('zz_bar') +' '+ $t('zz_called')+' ?'"
                                                    name="businessName"
                                                    type="text"
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('businessName')"
                                                    data-vv-name="businessName"
                                                    required
                                                    class="styled-input pa-0 m-0 pb-1 pt-4 bname"
                                                    width="100%">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                :label="$t('zz_tell_us')"
                                                name="contactFirstName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('contactFirstName')"
                                                data-vv-name="contactFirstName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 ownername">
                                            </v-text-field>
                                        </v-row>
                                        <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                :label="$t('zz_enter_email')"
                                                name="email"
                                                type="email"
                                                v-validate="'required'"
                                                class="styled-input pa-0 m-0 bemail"
                                                width="100%"
                                                required>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-cols>
                            </v-card>
                            <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="businessRegister('Bar','#frmbar','453')">{{$t('zz_lets_go')}}</v-btn>

                        </v-form>
                    </v-col>

                    <!-- BAR SPORTS -->
                    <v-col v-if="filterType=='' || filterType=='bar' || filterType=='foodbev' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <!-- <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span> -->
                            <v-img :src="barsports" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <!-- <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p> -->
                                <p class="bus-type-heading ">{{$t('zz_bar_sports')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-form v-model="valid"  id="frmbarsport" autocomplete="off" class="">

                            <v-card elevation=12 class="signup-card px-auto mx-auto">
                                <v-cols cols="12" class="text-center">
                                    <v-row no-gutters class="mx-3 pb-7">
                                        <v-row no-gutters cols="12" md="12" sm="12">
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                    :label="$t('zz_whats_your') +' '+ $t('zz_bar') +' '+ $t('zz_called')+' ?'"
                                                    v-model="businessName_sportsBar"
                                                    name="businessName"
                                                    type="text"
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('businessName')"
                                                    data-vv-name="businessName"
                                                    required
                                                    class="styled-input pa-0 m-0 pb-1 pt-4 bname"
                                                    width="100%">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                v-model="contactFirstName_sportsBar"
                                                :label="$t('zz_tell_us')"
                                                name="contactFirstName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('contactFirstName')"
                                                data-vv-name="contactFirstName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 ownername">
                                            </v-text-field>
                                        </v-row>
                                        <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                v-model="email_sportsBar"
                                                :label="$t('zz_enter_email')"
                                                name="email"
                                                type="email"
                                                v-validate="'required'"
                                                class="styled-input pa-0 m-0 bemail"
                                                width="100%"
                                                required>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-cols>
                            </v-card>
                            <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="businessRegister('BarSport','#frmbarsport','453')">{{$t('zz_lets_go')}}</v-btn>
                        </v-form>
                    </v-col>

                    <!-- BAR COCKTAIL -->
                    <v-col v-if="filterType=='' || filterType=='bar' || filterType=='foodbev' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <!-- <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span> -->
                            <v-img :src="barcocktail" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <!-- <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p> -->
                                <p class="bus-type-heading ">{{$t('zz_bar_cocktail')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-form v-model="valid"  id="frmbarcocktail" autocomplete="off" class="">

                            <v-card elevation=12 class="signup-card px-auto mx-auto">
                                <v-cols cols="12" class="text-center">
                                    <v-row no-gutters class="mx-3 pb-7">
                                        <v-row no-gutters cols="12" md="12" sm="12">
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                    :label="$t('zz_whats_your') +' '+ $t('zz_bar') +' '+ $t('zz_called')+' ?'"
                                                    v-model="businessName_cocktialBar"
                                                    name="businessName"
                                                    type="text"
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('businessName')"
                                                    data-vv-name="businessName"
                                                    required
                                                    class="styled-input pa-0 m-0 pb-1 pt-4 bname"
                                                    width="100%">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                v-model="contactFirstName_cocktialBar"
                                                :label="$t('zz_tell_us')"
                                                name="contactFirstName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('contactFirstName')"
                                                data-vv-name="contactFirstName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 ownername">
                                            </v-text-field>
                                        </v-row>
                                        <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                v-model="email_cocktialBar"
                                                :label="$t('zz_enter_email')"
                                                name="email"
                                                type="email"
                                                v-validate="'required'"
                                                class="styled-input pa-0 m-0 bemail"
                                                width="100%"
                                                required>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-cols>
                            </v-card>
                            <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="businessRegister('BAR COCKTAIL','#frmbarcocktail','453')">{{$t('zz_lets_go')}}</v-btn>
                        </v-form>
                    </v-col>

                    <!-- CAFE -->
                    <v-col v-if="filterType=='' || filterType=='restaurant' || filterType=='bar' || filterType=='foodbev' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <v-img :src="cafe" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_cafe')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-form v-model="valid"  id="frmcafe" autocomplete="off" class="">

                            <v-card elevation=12 class="signup-card px-auto mx-auto">
                                <v-cols cols="12" class="text-center">
                                    <v-row no-gutters class="mx-3 pb-7">
                                        <v-row no-gutters cols="12" md="12" sm="12">
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                    :label="$t('zz_whats_your') +' '+ $t('zz_cafe') +' '+ $t('zz_called')+' ?'"
                                                    v-model="businessName_cafe"
                                                    name="businessName"
                                                    type="text"
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('businessName')"
                                                    data-vv-name="businessName"
                                                    required
                                                    class="styled-input pa-0 m-0 pb-1 pt-4 bname"
                                                    width="100%">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                v-model="contactFirstName_cafe"
                                                :label="$t('zz_tell_us')"
                                                name="contactFirstName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('contactFirstName')"
                                                data-vv-name="contactFirstName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 ownername">
                                            </v-text-field>
                                        </v-row>
                                        <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                v-model="email_cafe"
                                                :label="$t('zz_enter_email')"
                                                name="email"
                                                type="email"
                                                v-validate="'required'"
                                                class="styled-input pa-0 m-0 bemail"
                                                width="100%"
                                                required>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-cols>
                            </v-card>
                            <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="businessRegister('CAFE','#frmcafe','453')">{{$t('zz_lets_go')}}</v-btn>
                        </v-form>
                    </v-col>

                    <!-- COFFEE SHOP -->
                    <v-col v-if="filterType=='' || filterType=='restaurant' || filterType=='bar' || filterType=='foodbev' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <v-img :src="coffeeshop" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_coffee_shop')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-form v-model="valid"  id="frmcofeeshop" autocomplete="off" class="">

                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_coffe_shop') +' '+ $t('zz_called')+' ?'"

                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4 bname"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field

                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1 ownername">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_coffeeShop"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0 bemail"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="businessRegister('COFFEE SHOP','#frmcofeeshop','453')">{{$t('zz_lets_go')}}</v-btn>
                        </v-form>
                    </v-col>

<!-- BISTROT -->
                    <v-col v-if="filterType=='' || filterType=='restaurant' || filterType=='foodbev' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <v-img :src="bistrot" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_bistrot')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>

                        <v-form v-model="valid"  id="frmbistrot" autocomplete="off" class="">


                            <v-card elevation=12 class="signup-card px-auto mx-auto">
                                <v-cols cols="12" class="text-center">
                                    <v-row no-gutters class="mx-3 pb-7">
                                        <v-row no-gutters cols="12" md="12" sm="12">
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                    :label="$t('zz_whats_your') +' '+ $t('zz_bistrot') +' '+ $t('zz_called')+' ?'"
                                                    v-model="businessName_bistrot"
                                                    name="businessName"
                                                    type="text"
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('businessName')"
                                                    data-vv-name="businessName"
                                                    required
                                                    class="styled-input pa-0 m-0 pb-1 pt-4 bname"
                                                    width="100%">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                v-model="contactFirstName_bistrot"
                                                :label="$t('zz_tell_us')"
                                                name="contactFirstName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('contactFirstName')"
                                                data-vv-name="contactFirstName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 ownername">
                                            </v-text-field>
                                        </v-row>
                                        <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                            <v-text-field
                                                v-model="email_bistrot"
                                                :label="$t('zz_enter_email')"
                                                name="email"
                                                type="email"
                                                v-validate="'required'"
                                                class="styled-input pa-0 m-0 bemail"
                                                width="100%"
                                                required>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-cols>
                            </v-card>
                            <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="businessRegister('Bistrot','#frmbistrot','453')">{{$t('zz_lets_go')}}</v-btn>
                       </v-form>
                    </v-col>

<!-- HAIR & BEAUTY SALON wellness-->
                    <v-col v-if="filterType=='' || filterType=='wellness' || filterType=='retail' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="hairbeauty" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_hairbeauty')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_hairBeauty"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_hairBeauty"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_hairBeauty"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                         <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- Mens grooming-->
                    <v-col v-if="filterType=='' || filterType=='wellness' || filterType=='retail' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="mensgrooming" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_mens_grooming')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_mensGrooming"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_mensGrooming"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_mensGrooming"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                         <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- RETAIL Business-->
                    <v-col v-if="filterType=='' || filterType=='retail' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="shop" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_shop')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_retail"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_retail"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_retail"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- FASHION SPORTS  -->
                    <v-col v-if="filterType=='' || filterType=='retail' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="fashionsports" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_fashion_sports')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_fashionSports"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_fashionSports"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_fashionSports"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- RETAIL Fashion Mens-->
                    <v-col v-if="filterType=='' || filterType=='retail' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="fashionmens" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_fashion_mens')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_fashionMens"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_fashionMens"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_fashionMens"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- RETAIL Fashion Womens-->
                    <v-col v-if="filterType=='' || filterType=='retail' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="fashionwomens" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_fashion_womens')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_fashionWomens"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_fashionWomens"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_fashionWomens"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- RETAIL Fashion Kids-->
                    <v-col v-if="filterType=='' || filterType=='retail' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="fashionkids" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_fashion_kids')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_fashionKids"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_fashionKids"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_fashionKids"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- BAKERY -->
                    <v-col v-if="filterType=='' || filterType=='retail' || filterType=='foodbev' || filterType=='highstreet'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="bakery" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_are_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_bakery')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_bakery') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_bakery"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_bakery"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_bakery"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- HOTEL Boutique  -->
                    <v-col v-if="filterType=='' || filterType=='hotel' || filterType==''" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="hotelboutique" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_hotel_boutique')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_hotel_chain') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_hotelBoutique"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_hotelBoutique"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_hotelBoutique"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                       <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- HOTEL Agroturismo  -->
                    <v-col v-if="filterType=='' || filterType=='hotel' || filterType==''" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="agriturismo" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_hotel_agro')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_hotelAgro"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_hotelAgro"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_hotelAgro"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                       <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- HOTEL Independant  -->
                    <v-col v-if="filterType=='' || filterType=='hotel' || filterType==''" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="hotelindpendant" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_an')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_hotel_independant')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_hotel') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_hotelIndependant"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_hotelIndependant"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_hotelIndependant"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                       <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- HOTEL CHAIN  -->
                    <v-col v-if="filterType=='' || filterType=='hotel' || filterType==''" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="hotelchain" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_hotel_chain')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_hotel_chain') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_hotelChain"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_hotelChain"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_hotelChain"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                       <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- HOTEL FRANCHISE -->
                    <v-col v-if="filterType=='' || filterType=='hotel' || filterType==''" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="hotelfranchise" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_hotel_franchise')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_hotel_franchise') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_hotelFranchise"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_hotelFranchise"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_hotelFranchise"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                       <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- HOTEL RESORT  -->
                    <v-col v-if="filterType=='' || filterType=='hotel' || filterType==''" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="hotelresort" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_hotel_resort')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_hotel') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_hotelResort"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_hotelResort"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_hotelResort"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                       <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- ATTRACTIONS -->
                    <v-col v-if="filterType=='' || filterType=='attraction' || filterType=='experience'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="attraction" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_an')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_attraction')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_attraction"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_attraction"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_attraction"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- STAGESHOW -->
                    <v-col v-if="filterType=='' || filterType=='attraction' || filterType=='experience'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="stageshow" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_stageshow')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_produciton') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_stageshow"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_stageshow"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_stageshow"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- VENUE -->
                    <v-col v-if="filterType=='' || filterType=='weddings' || filterType=='eventsorg'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="venue" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_an')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_venue')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_venue') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_venue"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_venue"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_venue"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- EVENT ORGANISER -->
                    <v-col v-if="filterType=='' || filterType=='' || filterType=='eventsorg'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="event" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_are_an')"></span></p>
                                 <p class="bus-type-heading ">{{$t('zz_event_organiser')}}</p>
                                 <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_eventOrganiser"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_eventOrganiser"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_eventOrganiser"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- WHOLESELLER -->
                    <v-col v-if="filterType=='' || filterType=='' || filterType=='wholeseller'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="wholeseller" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_are_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_distributor')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_wholeseller"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_wholeseller"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_wholeseller"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- DRINKS DISTRIBUTOR -->
                    <v-col v-if="filterType=='' || filterType=='' || filterType=='wholeseller'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="winedist" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_are_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_wine_dist')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_drinksDistributor"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_drinksDistributor"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_drinksDistributor"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                         <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- GYM -->
                    <v-col v-if="filterType=='' || filterType=='sports' || filterType=='highstreet'|| filterType=='gym'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="gym" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_gym')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_gym"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_gym"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_gym"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- GOLF CLUB -->
                    <v-col v-if="filterType=='' || filterType=='sports' || filterType=='highstreet'|| filterType=='gym'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="golfclub" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_golf_club')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_golf_club"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_golf_club"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_golf_club"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- Tennis Club -->
                    <v-col v-if="filterType=='' || filterType=='sports' || filterType=='highstreet'|| filterType=='gym'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="tennisclub" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_tennis_club')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_business') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_tennisClub"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_tennisClub"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_tennisClub"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

<!-- PADDEL Club -->
                    <v-col v-if="filterType=='' || filterType=='sports' || filterType=='highstreet'|| filterType=='gym'" cols="1" class="card text-center" style="max-width:400px">
                        <v-card elevation=5 class="pa-0 ma-0 ">
                            <img :src="comingSoon" class="comingsoon"/>
                            <v-span class="comingsoon-text">{{$t('zz_coming_soon')}}</v-span>
                            <v-img :src="paddelclub" class="main-image" gradient="to top right, rgba(251,251,251,.1), rgba(25,25,25,.7)">
                                <p style="text-transform: uppercase" class="sign-up-text"><span v-html="$t('zz_if_you_have_a')"></span></p>
                                <p class="bus-type-heading ">{{$t('zz_paddel_club')}}</p>
                                <v-img contain :src="whitejuzzapLogo" class="white-zz-logo small-logo pa-3"></v-img>
                            </v-img>
                        </v-card>
                        <v-card elevation=12 class="signup-card px-auto mx-auto">
                            <v-cols cols="12" class="text-center">
                                <v-row no-gutters class="mx-3 pb-7">
                                    <v-row no-gutters cols="12" md="12" sm="12">
                                        <v-col cols="12" md="12">
                                            <v-text-field
                                                :label="$t('zz_whats_your') +' '+ $t('zz_paddel_club') +' '+ $t('zz_called')+' ?'"
                                                v-model="businessName_paddelClub"
                                                name="businessName"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('businessName')"
                                                data-vv-name="businessName"
                                                required
                                                class="styled-input pa-0 m-0 pb-1 pt-4"
                                                width="100%">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="contactFirstName_paddelClub"
                                            :label="$t('zz_tell_us')"
                                            name="contactFirstName"
                                            type="text"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('contactFirstName')"
                                            data-vv-name="contactFirstName"
                                            required
                                            class="styled-input pa-0 m-0 pb-1">
                                        </v-text-field>
                                    </v-row>
                                    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
                                        <v-text-field
                                            v-model="email_paddelClub"
                                            :label="$t('zz_enter_email')"
                                            name="email"
                                            type="email"
                                            v-validate="'required'"
                                            class="styled-input pa-0 m-0"
                                            width="100%"
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-cols>
                        </v-card>
                        <v-btn  elevation=24 class="button-signup px-3" color="#FE5800"  @click="addBusinessType">{{$t('zz_lets_go')}}</v-btn>
                    </v-col>

                </div>

                </div>

                </div>



<!-- OLD OPTIONS -->
            <!-- <v-card class="overview" elevation="0">
                <v-card-title class="pa-0">
                    <v-row class="ma-12 pa-12">
                    <v-col cols="12" md="12" class="text-center card-text-container">
                        <img :src="juzzapLogo" width="100" />
                    </v-col>
                    </v-row>
                </v-card-title>
                <v-card-content>
                    <v-row>
                        <v-col cols="12" class="text-center pa-0 my-5 px-3 mx-3 ">
                            <span class="text-center">
                                    {{$t('zz_register_text')}}
                            </span>
                        </v-col>

                    </v-row>
                </v-card-content>
                <v-card-text class="ma-0 pa-0">

                    <v-row class="card-text-container parent">
                        <v-col cols="12" class="text-center box" >
                            <v-card elevation=24 @click="businessRegister('restaurants')">
                                <v-card-text>
                                    <div><img  :src="restImg"  style="max-height:100px"/></div>
                                    <div class="fs">RESTAURANTS<br></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" class="text-center box">
                            <v-card elevation=24 @click="businessRegister('bar')" >
                                <v-card-text>
                                    <div><img  :src="barImg"  style="max-height:100px"/></div>
                                    <div class="fs">BAR'S & CAFE'S<br></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" class="text-center box" >
                            <v-card elevation=24 @click="businessRegister('restaurants')">
                                <v-card-text>
                                    <div><img  :src="distImg"  style="max-height:100px"/></div>
                                    <div class="fs">DISTRIBUTOR & WHOLESALE</div>
                                </v-card-text>
                            </v-card>
                        </v-col>


                        <v-col cols="12" class="text-center box">
                            <v-card elevation=24 @click="businessRegister('retail')">
                                <v-card-text>
                                    <div><img  :src="retailImg"  style="max-height:100px"/></div>
                                    <div class="fs">RETAIL SHOPS<br></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" class="text-center box">
                            <v-card elevation=24 @click="businessRegister('hotel')">
                                <v-card-text>
                                    <div><img  :src="hotelImg"  style="max-height:100px"/></div>
                                    <div class="fs">HOTELS & APARTMENTS<br></div>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" class="text-center box">
                            <v-card elevation=24 @click="businessRegister('attractions')">
                                <v-card-text>
                                    <div><img  :src="attrImg"  style="max-height:100px"/></div>
                                    <div class="fs">ATTRACTIONS<br></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" class="text-center box">
                            <v-card elevation=24 @click="businessRegister('events')">
                                <v-card-text>
                                    <div><img  :src="eventImg"  style="max-height:100px"/></div>
                                    <div class="fs">EVENTS<br></div>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" class="text-center box">
                        <v-card elevation=24  @click="businessRegister('transport')">
                            <v-card-text>
                                    <div><img  :src="transImg"  style="max-height:100px"/></div>
                                    <div class="fs">TRANSPORT<br></div>
                            </v-card-text>
                        </v-card>
                        </v-col>
                        <v-col cols="12" class="text-center box">
                            <v-card elevation=24 @click="businessRegister('gym')">
                                <v-card-text>
                                    <div><img  :src="gymImg"  style="max-height:100px"/></div>
                                    <div class="fs">GYM<br></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-col cols="12" class="text-center ">
                            <v-card elevation=24 @click="businessRegister('gym')">
                                <v-card-text>
                                    <div><img  :src="distImg"  style="max-height:200px"/></div>
                                    <div class="fs">OTHER REAL WORLD BRICK & MORTAR BUSINESS<br></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                </v-card-text>
            </v-card> -->

        </v-col>
    </v-container>
</template>
<script>

import Vue from 'vue'
export default {
     props: {
    source: String
  },
  data: () => ({
      overlay: false,

    businessType:'',
    juzzapLogo: require("@/assets/juZZap-orange.svg"),
    whitejuzzapLogo: require("@/assets/logos/juZZap-filled-white-100H.svg"),
    barImg:require("@/assets/Bar.svg"),
    restImg:require("@/assets/rest.svg"),
    retailImg:require("@/assets/shop.svg"),
    hotelImg:require("@/assets/hotel.svg"),
    attrImg:require("@/assets/Attractions.svg"),
    eventImg:require("@/assets/Event.svg"),
    transImg:require("@/assets/transport.svg"),
    gymImg:require("@/assets/Gym.svg"),
    distImg:require("@/assets/Distribution-Wholesale.svg"),
    placeholder:require("@/assets/cityscape1.jpeg"),
    comingSoon:require("@/assets/coming-soon.svg"),



    blank:require("@/assets//onboarding/image-456.jpg"),
    restaurant:require("@/assets/onboarding/image-125.jpg"),
    bar:require("@/assets/onboarding/image-080.jpg"),
    barsports:require("@/assets/onboarding/image-510.jpg"),
    barcocktail:require("@/assets/onboarding/image-512.jpg"),
    cafe:require("@/assets/onboarding/image-316.jpg"),
    coffeeshop:require("@/assets/onboarding/image-095.jpg"),
    winedist:require("@/assets/onboarding/image-082.jpg"),

    fashion:require("@/assets/onboarding/image-268.jpg"),
    fashionmens:require("@/assets/onboarding/image-268.jpg"),
    fashionwomens:require("@/assets/onboarding/image-268.jpg"),
    fashionkids:require("@/assets/onboarding/image-268.jpg"),
    fashionsports:require("@/assets/onboarding/image-268.jpg"),

    agriturismo:require("@/assets/onboarding/image-252.jpg"),
    hotel:require("@/assets/onboarding/image-014.jpg"),
    hotelindpendant:require("@/assets/onboarding/image-014.jpg"),
    hotelfranchise:require("@/assets/onboarding/image-073.jpg"),
    hotelchain:require("@/assets/onboarding/image-282.jpg"),
    hotelboutique:require("@/assets/onboarding/image-149.jpg"),
    hotelresort:require("@/assets/onboarding/image-246.jpg"),

    bakery:require("@/assets/onboarding/image-005.jpg"),
    wine:require("@/assets/onboarding/image-009.jpg"),
    wholeseller:require("@/assets/onboarding/image-017.jpg"),
    attraction:require("@/assets/onboarding/image-010.jpg"),
    stageshow:require("@/assets/onboarding/pirates-adventure.jpg"),
    golfclub:require("@/assets/onboarding/image-283.jpg"),
    tennisclub:require("@/assets/onboarding/image-357.jpg"),
    paddelclub:require("@/assets/onboarding/image-410.jpg"),
    gym:require("@/assets/onboarding/image-151.jpg"),
    wineshop:require("@/assets/onboarding/image-020.jpg"),
    event:require("@/assets/onboarding/image-167.jpg"),
    venue:require("@/assets/onboarding/image-437.jpg"),
    transport:require("@/assets/onboarding/image-001.jpg"),
    bistrot:require("@/assets/onboarding/image-132.jpg"),
    // take-a-way:require("@/assets/onboarding/image-001.jpg"),
    shop:require("@/assets/onboarding/image-221.jpg"),
    hairbeauty:require("@/assets/onboarding/image-513.jpg"),
    mensgrooming:require("@/assets/onboarding/image-349.jpg"),
    // shop:require("@/assets/onboarding/image-001.jpg"),
    // :require("@/assets/onboarding/image-001.jpg"),

    filterType:'',





  }),
  methods:{
      businessRegister(btype,frmid,sckeltonid)
      {
        // this.$router.push({name:"businessregister",params: { type: btype }});
        var bname='';
        var ownername='';
        var bemail='';

        bname=document.querySelector(frmid+' .bname input').value;
        ownername=document.querySelector(frmid+' .ownername input').value;
        bemail=document.querySelector(frmid+' .bemail input').value;





        // bname=document.getElementById(bid).value;

        // alert('bname '+bname.value+'ownername '+ownername.value+'bemail '+bemail.value);

        this.overlay=true;


        this.$http
          .post(this.$apidomain+"createbusinessregister", {businessName:bname,email:bemail,businessType:btype,ownername:ownername,sckeltonid:sckeltonid})
          .then(res => {
            if(res.data.success)
            {
                let businesscode=res.data.business.businesscode;

                this.overlay=false;

                this.$router.push({name:'emailsend'});

            }
            else
            {
                let errmsg=[];
                for(var prop in res.data.errors){
                    errmsg.push(res.data.errors[prop][0]);
                }
                this.overlay=false;
                alert(errmsg[0]);

            }
          })
          .catch(err => {
            console.log(err.response);
            this.overlay=false;
          });

      }
  }
}
</script>

<style scoped>

.fs{
    font-size:12px;
}
.p-10 {
  padding: 10px;
}
.pwa-content {
  margin-top: -63px;
}
#mainhomecontainer.container {
  width: 100%;
  max-width: 100%;
}
#mainhomecontainer.container .heading {
  color: #fff;
}
.topbg {
  background: #fe5800;
}
.card-text-container{
    display: flex;
    flex-direction: row;
    justify-content:center;
    align-items: center;
    align-content: center;
    padding-top: 32px;
    padding-bottom: 0px;
    padding-left: 8px;
    padding-right: 8px;

}
.parent {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .box {
  /*   flex: 1 1 150px;  Stretching: */
    flex: 0 1 300px; /*  No stretching: */
    margin: 5px;

  }
  .bus-card-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    grid-gap: 1rem;
    /* display: grid;
    /* grid-gap: 1rem; */
    /* grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));  */

  }
  .main-image{
      object-fit: contain;
      object-position: bottom left;
      height: 400px;
      width: 300px;
      filter: hue-rotate(20deg);
  }
  .main-image .imagezoomfast{
  animation: beat 35s infinite alternate;
  /* animation:scale 60s forwards; */
  transform-origin:50% 50%;
  transform:scale(1);

}
.card {
    /*  flex: 1 1 300px; /*  Stretching: */
   flex: 0 1 300px; /*  No stretching: */
    margin: 5px;
    /* max-width: 600px; */
    /* max-height: 250px; */

  }
  .comingsoon{
    position: absolute;
    left: -17px;
    top: -18px;
    z-index: 1;
    width: 203px;

  }
  .comingsoon-text{
        position: absolute;
    left: -66px;
    top: 21px;
    z-index: 2;
    width: 203px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    font-weight: 600;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    /* text-transform: uppercase; */

  }
  .bus-type-heading{
    /* font-size:24px; */
    font-weight: 600;
    /* color: #fff; */
    border: 2px solid rgba(255, 255, 255, 0.5);
    color: #ffffff;
    padding: 10px;
    /* max-width: fit-content; */
    max-width: 80%;
    position: relative;
    top: 20%;
    margin: 0 auto;
    border-radius: 3px;
    font-size:clamp(20px, 32px, 50px) !important;
    line-height: .85;
    text-align: center;
    /* letter-spacing: 2px; */
  }
  .bus-type-heading:hover {

  background-color: rgba(0,0,0,0.5);
  transform: scale(1.1);
}

.main-image:hover {
  filter: hue-rotate(0deg);
}

.signup-card{
    /* position: relative; */
    top: -75px;
    width: 90%;
    background: rgb(255,255,255);
    background: linear-gradient(145deg, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.1) 75%);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);


}
.button-signup{
    color: white;
    position: relative;
    top: -90px;
    /* height: 100px; */
    padding: 12px;
    border-radius: 3px;
    /* width: 80%; */
    line-height: 1;

}
.button-signup2{
    color: rgb(255, 255, 255);
    position: relative;
    top: -20px;
    /* height: 100px; */
    padding: 12px;
    border-radius: 3px;
    /* width: 80%; */
    line-height: 1;

}

.absolute-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

  .sign-up-text{
    /* font-size:clamp(12px, 1vw, 150px); */
    font-size: 12px;
    line-height: .5;
    color: #ffffff;
    position: relative;
    top: 40px;

  }
  .sign-up-text2{
    /* font-size:clamp(12px, 1vw, 150px); */
    width: 250px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    color: #ffffff;
    position: absolute;
    bottom: 50px;
    left: 25px;


  }
  .max-h-200{
      /* width: 100% !important; */
      max-height: 100vh;
      position: sticky;
  }
.styled-input{
font-size: 20px
}

.bus-card-image-grad{
    background: rgb(129,129,129);
    background: linear-gradient(8deg, rgba(129,129,129,0.8897934173669468) 0%, rgba(116,116,116,0.8673844537815126) 48%, rgba(150,150,150,0.4640231092436975) 100%);
}
.head-line{
    font-size:clamp(30px, 4vw, 60px) !important;
    font-weight: 1000 !important;
    text-align: center;
    color: #fe5800;
    line-height: .75;
    text-transform: uppercase;
}

.strapline1{
    font-size:clamp(25px, 4vw, 50px) !important;
    font-weight: 800;
    text-align: center;
    line-height: .85;
}
.txt1{
    font-size:clamp(12px, 1vw, 30px) !important;
    font-weight: 800;
    text-align: center;
    text-transform: uppercase;
    line-height: .75;


}
.txt1-2{
    font-size:clamp(10px, 1vw, 24px) !important;
    font-weight: 400;
    text-align: center;
    text-align: center;
    line-height: 1;
}
.txt2{
    font-size:clamp(14px, 2vw, 24px) !important;
    font-weight: 300;
    text-align: center;
    line-height: .85;
    /* text-align: justify; */

}
.txt3{
    font-weight: 300;
    text-align: center;
}
.txt4{
    font-size:clamp(25px, 3vw, 50px) !important;
    font-weight: 600;
    text-align: center;
    line-height: .95;

}
.prereg{
    font-size:clamp(10px, 1vw, 20px) !important;
    font-weight: 500;
    text-align: center;
    line-height: 1;
    /* color: #fe5800; */
}
.small-logo{
    height: 50px;

}
.max-400{
    max-width: 400px;
}
.white-zz-logo{
    position: relative;
    top: 100px;
    height: 30px !important;


}
.{
  display: grid;
  place-items: center;
  height: 100vh;
}

</style>
